var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    width: 42.1429,
    height: 39.2857,
    rx: 10,
    fill: "#FFA4A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8322 30.0225H16.3178C15.561 30.0225 14.8352 29.7223 14.2995 29.1879C13.7637 28.6535 13.4618 27.9283 13.46 27.1716V11.3394C13.46 11.1559 13.5328 10.9799 13.6626 10.8501C13.7924 10.7203 13.9684 10.6475 14.1519 10.6475H27.9912C28.1747 10.6475 28.3507 10.7203 28.4805 10.8501C28.6103 10.9799 28.6832 11.1559 28.6832 11.3394V27.1716C28.6814 27.9271 28.3804 28.6512 27.8461 29.1855C27.3119 29.7197 26.5878 30.0207 25.8322 30.0225L25.8322 30.0225ZM14.8438 12.0314V27.1716C14.8456 27.5612 15.0017 27.9344 15.2779 28.2093C15.5542 28.4842 15.928 28.6385 16.3177 28.6385H25.8321C26.2206 28.6367 26.5927 28.4815 26.8674 28.2068C27.1421 27.9321 27.2973 27.5601 27.2991 27.1716V12.0314H14.8438Z",
    fill: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0714 11.824C20.8878 11.824 20.7118 11.7511 20.5821 11.6213C20.4523 11.4915 20.3794 11.3155 20.3794 11.132V9.95566C20.3794 9.70844 20.5113 9.48001 20.7254 9.35638C20.9395 9.23277 21.2033 9.23277 21.4173 9.35638C21.6314 9.48 21.7633 9.70842 21.7633 9.95566V11.132C21.7633 11.3155 21.6905 11.4915 21.5606 11.6213C21.4309 11.7511 21.2549 11.824 21.0714 11.824Z",
    fill: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7589 12.0314H11.3839C11.1367 12.0314 10.9082 11.8995 10.7846 11.6854C10.661 11.4713 10.661 11.2075 10.7846 10.9934C10.9082 10.7794 11.1366 10.6475 11.3839 10.6475H30.7589C31.0061 10.6475 31.2345 10.7794 31.3582 10.9934C31.4818 11.2075 31.4818 11.4713 31.3582 11.6854C31.2345 11.8995 31.0061 12.0314 30.7589 12.0314Z",
    fill: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6114 27.2122C17.4279 27.2122 17.2519 27.1393 17.1221 27.0095C16.9923 26.8798 16.9194 26.7038 16.9194 26.5202V15.5318C16.9194 15.2846 17.0513 15.0562 17.2654 14.9326C17.4795 14.8089 17.7433 14.8089 17.9574 14.9326C18.1715 15.0562 18.3034 15.2846 18.3034 15.5318V26.5202C18.3034 26.7037 18.2305 26.8798 18.1007 27.0095C17.9709 27.1393 17.7949 27.2122 17.6114 27.2122Z",
    fill: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5313 27.2122C24.3478 27.2122 24.1718 27.1393 24.042 27.0095C23.9122 26.8798 23.8394 26.7038 23.8394 26.5202V15.5318C23.8394 15.2846 23.9713 15.0562 24.1853 14.9326C24.3994 14.8089 24.6632 14.8089 24.8773 14.9326C25.0914 15.0562 25.2233 15.2846 25.2233 15.5318V26.5202C25.2233 26.7037 25.1504 26.8798 25.0206 27.0095C24.8909 27.1393 24.7148 27.2122 24.5313 27.2122Z",
    fill: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0714 27.2122C20.8878 27.2122 20.7118 27.1393 20.5821 27.0095C20.4523 26.8798 20.3794 26.7038 20.3794 26.5202V15.5318C20.3794 15.2846 20.5113 15.0562 20.7254 14.9326C20.9395 14.8089 21.2033 14.8089 21.4173 14.9326C21.6314 15.0562 21.7633 15.2846 21.7633 15.5318V26.5202C21.7633 26.7037 21.6905 26.8798 21.5606 27.0095C21.4309 27.1393 21.2549 27.2122 21.0714 27.2122Z",
    fill: "#FFA4A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1429,
    height: 22.1429,
    fill: "white",
    transform: "translate(10 8.57129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.95236f11493282720c91970bee7adcd9.svg";
export { ForwardRef as ReactComponent };